import { NamedProperty } from "sprint-common-web";

import { FramerateProfileLookupResponse } from "../api/orders-api/framerate-profile/responses/GetFramerateProfilesLookupResponse";

export type FramerateProfile = NamedProperty;

export const mapToFramerateProfile = (response: FramerateProfileLookupResponse): FramerateProfile => ({
    id: response.id,
    name: response.name
});
